import { HttpErrorResponse } from '@angular/common/http';
import {
  PayOnAccountPaymentPreviewV1Response,
  PreAuthorizedDebitMode,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PayOnAccountCoreComponentActions = createActionGroup({
  source: 'Pay On Account Core Component',
  events: {
    'Initialize Pay On Account Core Action': props<{ sessionId: string }>(),
    'Load Pre Authorized Debit Mode Success': props<{
      payload: PreAuthorizedDebitMode;
    }>(),
    'Load Pre Authorized Debit Mode Error': props<{
      error: HttpErrorResponse;
    }>(),
    'Create Pay On Account Payment Preview Complete Action': props<{
      payload: PayOnAccountPaymentPreviewV1Response;
    }>(),
    'Create Pay On Account Payment Preview Error Action': emptyProps(),
    'Skip Pay On Account Payment Preview Action': emptyProps(),
  },
});
